export default "__VITE_ASSET__kOEEFbbc__"